import BpkText, {
  TEXT_COLORS,
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import type { I18nService } from '@shared/types/i18n';

import STYLES from './NoOfferPrompt.module.scss';

import BpkBreakpoint, { BREAKPOINTS } from '@shared/ui/common/BpkBreakpoint';
import NotFound from '@shared/ui/common/NotFound';
import { withI18n } from '@shared/ui/contexts/i18n';

const cls = cssModules(STYLES);
const DESKTOP_IMAGE_HEIGHT = '175';
const MOBILE_IMAGE_HEIGHT = '150';

const NoOfferPrompt = ({ i18n }: { i18n: I18nService }) => (
  <div className={cls('NoOfferPrompt')}>
    <BpkBreakpoint query={BREAKPOINTS.MOBILE}>
      {(isActive: boolean) => (
        <>
          <div className={cls('NoOfferPrompt__image')}>
            <NotFound
              height={isActive ? MOBILE_IMAGE_HEIGHT : DESKTOP_IMAGE_HEIGHT}
            />
          </div>
          <div className={cls('NoOfferPrompt__desc')}>
            <BpkText
              textStyle={isActive ? TEXT_STYLES.label1 : TEXT_STYLES.heading4}
              className={cls('NoOfferPrompt__header')}
            >
              {i18n.translate('Error_label_ratesUnavailable')}
            </BpkText>
            <BpkText
              tagName="p"
              textStyle={
                isActive ? TEXT_STYLES.footnote : TEXT_STYLES.bodyDefault
              }
              className={cls('NoOfferPrompt__text')}
              color={TEXT_COLORS.textSecondary}
            >
              {i18n.translate('RoomOptions_label_noDeals_message')}
            </BpkText>
          </div>
        </>
      )}
    </BpkBreakpoint>
  </div>
);

export default withI18n(NoOfferPrompt);
